import React from "react";
import "./TicTacToeIntro.css"; // Import the CSS file for styling
import { useNavigate } from "react-router-dom";
const TicTacToeIntro = () => {
  const navigate = useNavigate();
  const handlePlayNow = () => {
    // Navigate to the game page
    navigate("/gamePage");
  };

  return (
    <div className="hero-section">
      <img
        src="https://w0.peakpx.com/wallpaper/128/237/HD-wallpaper-tic-tac-toe-game-blue-background-ultra-games-other-games-color-game-design-blue-tictactoe-chalkboard-chalk-diagonal-row-winner-solved-grid-xsandos-noughtsandcrosses-blackboard.jpg"
        alt=""
        className="Tick_tack_toe"
      />
      <h1>Challenge a Friend in Tic-Tac-Toe!</h1>
      <p className="IntroTXT">
        Ultimate battle of wits, can you outsmart your opponent?
      </p>
      <button className="cta-button" onClick={handlePlayNow}>
        Start Playing Now!
      </button>
    </div>
  );
};

export default TicTacToeIntro;
